import FaroSphereLogoMini from "@assets/logo/faro-sphere-xg-logo-mini.svg?react";
import { ExchangeArrowsIcon, Dialog } from "@flat-ui";
import { Box, Stack, Typography } from "@mui/material";
import { IntegrationIcon } from "@pages/project-details/project-integrations/integration-icon";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { memo } from "react";

interface Props {
  /** Integration ID */
  integrationId: FaroCoreApiTypes.IntegrationId;

  /** Callback while closing the dialog */
  onClose(): void;
}

/** Renders project integration connected dialog */
function ProjectIntegrationsConnectedDialogComponent({
  integrationId,
  onClose,
}: Props): JSX.Element {
  return (
    <Dialog open={true} title="" onConfirm={onClose} confirmText="Got it">
      <Stack textAlign="center">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 3,
            marginY: "60px",
            marginX: "auto",
          }}
        >
          <IntegrationIcon icon={FaroSphereLogoMini} />
          <ExchangeArrowsIcon />
          <IntegrationIcon icon={INTEGRATION_INFO[integrationId].icon} />
        </Box>

        <Typography
          sx={{
            fontSize: "20px",
            marginBottom: "10px",
          }}
        >
          <var>{INTEGRATION_INFO[integrationId].displayName}</var> has been
          synced
        </Typography>

        <Typography
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
          }}
        >
          <var>{INTEGRATION_INFO[integrationId].displayName}</var> has been
          enabled in your Sphere XG project
        </Typography>
      </Stack>
    </Dialog>
  );
}

export const ProjectIntegrationsConnectedDialog = memo(
  ProjectIntegrationsConnectedDialogComponent
);
